import React from 'react';

import {createFormErrorsContext, FormControlGroup} from 'app/general/forms';
import {useAddCategory, useUpdateCategory} from 'app/kbs/api';
import {gt} from 'app/utils/i18n';

import {KBTreeEditItemName} from '../KBTreeEditItemStructure';

import type {FormErrorsProps} from 'app/general/forms';
import type {
  KBCategorySerializedType,
  KnowledgebaseSerializedType,
} from 'sweet-types';

type OwnProps = {
  kb: KnowledgebaseSerializedType;
  parentCategoryURL: string | null;
  category?: KBCategorySerializedType;
  onCancel: () => any;
  afterAction: () => any;
};
type ConnectedProps = OwnProps;
type Props = ConnectedProps & FormErrorsProps;

export const KBTreeEditCategory = createFormErrorsContext(
  ({
    kb,
    category,
    afterAction,
    parentCategoryURL,
    captureFormErrorsFromRejection,
    onCancel,
  }: Props) => {
    const [addCategory] = useAddCategory();
    const [updateCategory] = useUpdateCategory();
    function createOrUpdate(name: string, icon: string) {
      const payload = {
        name,
        icon,
        knowledgebase_url: kb.url,
        parent_category: parentCategoryURL,
      };
      return (
        category == null
          ? addCategory(payload).unwrap()
          : updateCategory({url: category.url, ...payload}).unwrap()
      ).then(afterAction, captureFormErrorsFromRejection);
    }

    return (
      <FormControlGroup field="name" className="flex-grow-1 mb-0">
        {(invalidFeedback, errorClass) => (
          <>
            <KBTreeEditItemName
              inputClass={errorClass}
              onCancel={onCancel}
              initialIcon={category != null ? category.icon : ''}
              initialValue={category != null ? category.name : ''}
              placeholder={gt('Category Name')}
              onSubmit={createOrUpdate}
            />
            {invalidFeedback}
          </>
        )}
      </FormControlGroup>
    );
  }
);
